module.exports = __webpack_public_path__ + "static/KC9-57cfcb0c17fe0c4cab717d91d2cb0362.png";